/* eslint-disable no-console */
export default class Console {
  static error(text) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(text);
    }
  }

  static warning(text) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(text);
    }
  }

  static log(text) {
    if (process.env.NODE_ENV !== 'production') {
      console.log(text);
    }
  }
}
/* eslint-enable */
